module.exports = __webpack_public_path__ + "static/media/scroll-down.8d8e1a34.svg";